/* NBA Store Chile - comportamiento de las secciones nba-* (sin dependencias) */
(function () {
  'use strict';
  var mqMob = window.matchMedia('(max-width: 749px)');
  var mqHoverNone = window.matchMedia('(hover: none)');
  var RECENT_KEY = 'nba:recent';
  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function store(get, key, val) { try { if (get) return localStorage.getItem(key); localStorage.setItem(key, val); } catch (e) { return null; } }

  /* Carruseles: flechas que aparecen solo cuando hay contenido para desplazar */
  function initRail(rail) {
    if (rail.dataset.nbaReady) return;
    rail.dataset.nbaReady = '1';
    var track = rail.querySelector('[data-nba-track]');
    var prev = rail.querySelector('[data-nba-prev]');
    var next = rail.querySelector('[data-nba-next]');
    if (!track) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.hidden = track.scrollLeft <= 2;
      if (next) next.hidden = max <= 0 || track.scrollLeft >= max;
    }
    function go(dir) { track.scrollBy({ left: dir * Math.max(track.clientWidth * 0.9, 160), behavior: 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (window.ResizeObserver) new ResizeObserver(update).observe(track);
    update();
  }

  /* Mega menu con intencion de hover, foco y toque */
  function closeMega(except) {
    all('[data-nba-nav-item].is-open').forEach(function (i) {
      if (i === except) return;
      i.classList.remove('is-open');
      var l = i.querySelector('.nba-nav__link');
      if (l) l.setAttribute('aria-expanded', 'false');
    });
  }
  function initNav(root) {
    all('[data-nba-nav-item]', root).forEach(function (item) {
      if (item.dataset.nbaReady || !item.querySelector('[data-nba-mega]')) return;
      item.dataset.nbaReady = '1';
      var link = item.querySelector('.nba-nav__link');
      var timer;
      function open() { clearTimeout(timer); timer = setTimeout(function () { closeMega(item); item.classList.add('is-open'); if (link) link.setAttribute('aria-expanded', 'true'); }, 90); }
      function close() { clearTimeout(timer); timer = setTimeout(function () { item.classList.remove('is-open'); if (link) link.setAttribute('aria-expanded', 'false'); }, 140); }
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      item.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeMega(); if (link) link.focus(); } });
      if (link) link.addEventListener('click', function (e) {
        if (mqHoverNone.matches && !item.classList.contains('is-open')) { e.preventDefault(); closeMega(item); item.classList.add('is-open'); link.setAttribute('aria-expanded', 'true'); }
      });
    });
  }

  /* Busqueda predictiva (Section Rendering API -> sections/nba-search-results) */
  function initSearch(form) {
    if (form.dataset.nbaReady) return;
    form.dataset.nbaReady = '1';
    var input = form.querySelector('[data-nba-search-input]');
    var box = form.querySelector('[data-nba-search-results]');
    if (!input || !box) return;
    var timer, ctrl, last = '';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    function hide() { box.hidden = true; input.setAttribute('aria-expanded', 'false'); }
    function show() { box.hidden = false; input.setAttribute('aria-expanded', 'true'); }
    function run() {
      var q = input.value.trim();
      if (q.length < 2) { hide(); return; }
      if (q === last && box.innerHTML) { show(); return; }
      last = q;
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var url = root + 'search/suggest?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,query&resources[limit]=6' +
        '&resources[options][unavailable_products]=last&section_id=nba-search-results';
      fetch(url, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var res = doc.querySelector('.nba-sr');
          box.innerHTML = res ? res.outerHTML : '';
          if (res) show(); else hide();
        })
        .catch(function () {});
    }
    input.setAttribute('aria-expanded', 'false');
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 220); });
    input.addEventListener('focus', function () { if (box.innerHTML && input.value.trim().length >= 2) show(); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { hide(); input.blur(); } });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) hide(); });
  }

  /* Vistos recientemente: se guardan las colecciones visitadas */
  function readRecent() { try { return JSON.parse(store(true, RECENT_KEY)) || []; } catch (e) { return []; } }
  function recordRecent() {
    var cur = window.NBA_RECENT;
    if (!cur || !cur.url) return;
    var list = readRecent().filter(function (x) { return x && x.url !== cur.url; });
    list.unshift({ title: cur.title, url: cur.url });
    store(false, RECENT_KEY, JSON.stringify(list.slice(0, 12)));
  }
  function initRecent(sec) {
    var list = sec.querySelector('[data-nba-recent-list]');
    if (!list) return;
    var max = parseInt(sec.getAttribute('data-max') || '6', 10);
    var items = readRecent().slice(0, max);
    if (!items.length && sec.hasAttribute('data-design-mode')) {
      items = [{ title: 'Poleras Lakers', url: '#' }, { title: 'Jerseys City Edition', url: '#' }, { title: 'Gorras New Era', url: '#' }];
    }
    if (!items.length) { sec.hidden = true; return; }
    list.innerHTML = '';
    items.forEach(function (it) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'nba-chip';
      a.href = it.url;
      a.textContent = it.title;
      li.appendChild(a);
      list.appendChild(li);
    });
    sec.hidden = false;
  }

  /* Popup de newsletter */
  var nlBound = false;
  function getDialog() { return document.querySelector('[data-nba-newsletter]'); }
  function openNl() {
    var d = getDialog();
    if (!d) return false;
    if (typeof d.showModal === 'function') { if (!d.open) d.showModal(); } else { d.setAttribute('open', ''); }
    return true;
  }
  function closeNl() {
    var d = getDialog();
    if (!d) return;
    if (d.open && typeof d.close === 'function') d.close(); else d.removeAttribute('open');
  }
  function initNewsletter() {
    if (!nlBound) {
      nlBound = true;
      document.addEventListener('click', function (e) {
        var t = e.target.closest ? e.target.closest('[data-nba-open-newsletter]') : null;
        if (t && openNl()) e.preventDefault();
        if (e.target.closest && e.target.closest('[data-nba-nl-close]')) { e.preventDefault(); closeNl(); }
        var d = getDialog();
        if (d && e.target === d) closeNl();
      });
    }
    var d = getDialog();
    if (!d || d.dataset.nbaReady) return;
    d.dataset.nbaReady = '1';
    if (d.querySelector('[data-nba-nl-ok]')) store(false, 'nba:nl-subscribed', '1');
    if (location.hash === '#NbaNewsletterForm') { openNl(); return; }
    if (d.getAttribute('data-auto') !== 'true' || store(true, 'nba:nl-subscribed')) return;
    var now = new Date();
    var today = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + now.getDate();
    var seen = store(true, 'nba:nl-seen');
    var due = d.getAttribute('data-frequency') === 'once' ? !seen : seen !== today;
    if (due) {
      setTimeout(function () {
        if (store(true, 'nba:nl-subscribed')) return;
        if (openNl()) store(false, 'nba:nl-seen', today);
      }, (parseInt(d.getAttribute('data-delay'), 10) || 10) * 1000);
    }
  }

  /* Franja de beneficios: en movil rota los mensajes */
  function initRotator(el) {
    if (el.dataset.nbaReady) return;
    el.dataset.nbaReady = '1';
    var msgs = all('.nba-promo__msg', el);
    if (msgs.length < 2) return;
    var i = 0;
    var ms = (parseInt(el.getAttribute('data-interval'), 10) || 5) * 1000;
    setInterval(function () {
      if (!mqMob.matches) return;
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, ms);
  }

  /* Contador del carro: Ella actualiza [data-cart-count]; aqui solo se oculta en 0 */
  function initCartCount() {
    all('.nba-util__count').forEach(function (b) {
      var n = b.querySelector('[data-cart-count]');
      if (!n || b.dataset.nbaReady) return;
      b.dataset.nbaReady = '1';
      function sync() { var v = n.textContent.trim(); b.hidden = (v === '' || v === '0'); }
      sync();
      new MutationObserver(sync).observe(n, { childList: true, characterData: true, subtree: true });
    });
  }

  /* Footer: columnas abiertas en escritorio, acordeon en movil */
  function syncFooter() {
    all('[data-nba-acc]').forEach(function (d) {
      if (!d.dataset.nbaBound) {
        d.dataset.nbaBound = '1';
        d.addEventListener('toggle', function () { if (mqMob.matches) d.dataset.nbaTouched = '1'; });
      }
      if (!mqMob.matches) d.open = true;
      else if (!d.dataset.nbaTouched) d.open = false;
    });
  }

  function initAll(root) {
    all('[data-nba-rail]', root).forEach(initRail);
    initNav(root);
    all('[data-nba-search]', root).forEach(initSearch);
    all('[data-nba-recent]', root).forEach(initRecent);
    all('[data-nba-rotator]', root).forEach(initRotator);
    initCartCount();
    syncFooter();
    initNewsletter();
  }

  recordRecent();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var li = e.target.closest ? e.target.closest('[data-nba-track] > li') : null;
    if (li) li.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'smooth' });
  });
  if (mqMob.addEventListener) mqMob.addEventListener('change', syncFooter); else if (mqMob.addListener) mqMob.addListener(syncFooter);
})();
